import { MutableRefObject, RefObject, useMemo } from 'react';

import { BryntumSchedulerPro } from '@bryntum/gantt-react';

import { SchedulerControls } from 'components/common/bryntumScheduler/SchedulerControlsHook';
import { DataConverterContract } from 'components/common/bryntumScheduler/types';
import { transformResponseToBryntumData } from 'components/common/bryntumScheduler/utils/defaultSchedulerDataTransform';

interface Props {
    data: any;
    dataConvertor?: (data: any) => DataConverterContract;
    controlsRef: MutableRefObject<SchedulerControls>;
    schedulerInstanceRef: RefObject<BryntumSchedulerPro>;
}

export const useSchedulerLogic = ({ data, dataConvertor }: Props) => {
    const { finishDate, startDate, events, resources, isValidDateRange } = useMemo(() => {
        const dataConvertorFunct = dataConvertor ?? transformResponseToBryntumData;
        return dataConvertorFunct(data);
    }, [data]);

    return {
        logic: {
            schedulerFormatedData: {
                resources,
                events,
                startDate,
                finishDate,
                isValidDateRange,
            },
        },
    };
};
